/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI76026ReqDeliverableListItem {
  
  /**  */
  deliverableUrl?: string;
  
  /**  */
  deliverableName?: string;
  
  /**  */
  deliverableDesc?: string;
  
};
    
  



export interface API76026Req {
  
  /** 任务实例code */
  bizNo: string;
  /** 交付物列表 ,TaskDeliverableReq */
  deliverableList?: IAPI76026ReqDeliverableListItem[];
};



export interface API76026Res {
  /** 鼓励  */
  taskTips?: string;
  /** 是否完成  */
  finish?: boolean;
  
};


// 接口函数 76026 完成任务实例

export interface IUsePostAPI76026Return {
  /** 完成任务实例: 接口请求状态 */
  isAPI76026Loading: boolean;
  /** 完成任务实例: 接口请求返回数据 */
  dataAPI76026: API76026Res;
  /**  完成任务实例: 接口数据请求方法 */
  fetchAPI76026Data: (inputs: API76026Req, config?: YWRequestConfig) => Promise<API76026Res>;
  /** 完成任务实例: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI76026 = ():IUsePostAPI76026Return => {
  let isMount = true;
  const [isAPI76026Loading, setIsAPI76026Loading] = useState(false);
  const [dataAPI76026, setDataAPI76026] = useState<API76026Res>({} as API76026Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/finish`;

  const fetchAPI76026Data = async (inputs: API76026Req, config?: YWRequestConfig): Promise<API76026Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76026Req>) || {}) as API76026Req;
    
  
    if ( isMount ) {
      setIsAPI76026Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API76026Res>(`${basePath}/yoaichat-web/task/instance/finish`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI76026(res || {} as API76026Res);
        setIsAPI76026Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76026Loading(false);
      }
      return false as unknown as API76026Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76026Loading,
    dataAPI76026,
    fetchAPI76026Data,
    requestUrl,
  }
}

